import { render, staticRenderFns } from "./NurseryEditPhotos.vue?vue&type=template&id=04cf36a8"
import script from "./NurseryEditPhotos.vue?vue&type=script&lang=js"
export * from "./NurseryEditPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports